import Api from "../../lib/api";

export const getActions = (resource) => ({
  start: `fetch_start/filters_data/${resource}`,
  success: `fetch_success/filters_data/${resource}`,
  error: `fetch_error/filters_data/${resource}`,
});

const fetchStart = (resource) => ({
  type: getActions(resource).start,
});

const fetchSuccess = (resource, data) => ({
  type: getActions(resource).success,
  data,
});

const fetchError = (resource, error) => ({
  type: getActions(resource).error,
  error,
});

const getResource = (resource, url = "", defaultFilter = undefined) => (
  filter
) => (dispatch) => {
  if (filter) {
    dispatch(fetchStart(resource));
    return Api.get(
      Api.API_FILTERS(
        url || resource,
        defaultFilter ? `?${defaultFilter}&name=${filter}` : `?name=${filter}`
      )
    )
      .then((response) => dispatch(fetchSuccess(resource, response.data)))
      .catch((error) => dispatch(fetchError(resource, error)));
  } else {
    dispatch(fetchSuccess(resource, []));
  }
};

const actions = {
  getDonors: getResource("donors"),
  getFields: getResource("fields"),
  getPortals: getResource("portals"), // getPortals: getResource("portals", "portals", "year=2020"),
  getSdgs: getResource("sdgs", "sectors", "sector_vocabulary__code=7"),
  getOecds: getResource("oecds", "sectors", "sector_vocabulary__code=1"),
  getHomeFields: getResource("homeFields", "fields"),
  getHomeDonors: getResource("homeDonors", "donors"),
  getHomeSdgs: getResource("homeSdgs", "sectors", "sector_vocabulary__code=7"),
  getHomeSectors: getResource(
    "homeSectors",
    "sectors",
    "sector_vocabulary__code=2"
  ),
};

const _getResource = (resource, url = "", defaultFilter = undefined) => (
  filter
) => (dispatch) => {
  if (filter) {
    dispatch(fetchStart(resource));
    return Api.get(
      Api.API_FILTERS(
        url || resource,
        defaultFilter ? `?${defaultFilter}&name=${filter}` : `?name=${filter}`
      )
    )
      .then((response) => dispatch(fetchSuccess(resource, response.data)))
      .catch((error) => dispatch(fetchError(resource, error)));
  } else {
    dispatch(fetchSuccess(resource, []));
  }
};

export const _actions = (filters) => {
  return {
    getPortals: _getResource("portals", "portals", filters),
  };
};

export default actions;



// WEBPACK FOOTER //
// ./shared/actions/getFiltersData.js